var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgYellowArrow = function SvgYellowArrow(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16682 2.49983V17.4998C4.1673 17.6517 4.20918 17.8006 4.28797 17.9304C4.36676 18.0602 4.47946 18.1661 4.61395 18.2367C4.74844 18.3072 4.89962 18.3397 5.05122 18.3307C5.20283 18.3218 5.34911 18.2716 5.47432 18.1857L16.3077 10.6857C16.7568 10.3748 16.7568 9.6265 16.3077 9.31483L5.47432 1.81483C5.34937 1.72801 5.20301 1.67711 5.05116 1.66763C4.8993 1.65816 4.74776 1.69048 4.61298 1.76109C4.47821 1.8317 4.36536 1.93789 4.2867 2.06813C4.20804 2.19837 4.16658 2.34768 4.16682 2.49983Z",
    fill: "#F2A742"
  })));
};
export default SvgYellowArrow;